module.exports = __webpack_public_path__ + "img/Special.041f4820.png";